import { useContext } from "react";
import { firebaseLogOut } from "../services/authServices/auth.services";
import { AppGlobalContext } from "../contexts/AppContext.context";
import { useNavigate } from "react-router-dom";

const useLogoutHook = () => {
  const navigate = useNavigate();
  const { SetAppState } = useContext(AppGlobalContext);

  // Function to handle user logout
  const handleUserLogout = async () => {
    await firebaseLogOut();
    window.sessionStorage.clear();
    SetAppState({
      isAuthUser: false,
      loggedInUserRole: null,
      authUserDetails: {},
    });
    
    // Trigger storage event to notify other tabs about logout
    localStorage.setItem('logout-event', Date.now().toString());
    localStorage.removeItem('logout-event');
    
    navigate("/");
    window.history.pushState(null, "", "/");
  };

  return { handleUserLogout };
};

export default useLogoutHook;
